'use client';

import React from 'react';
import { MoneyPageTemplate, NewsTemplate } from '@benzinga/money';
import type { Breadcrumb } from '@benzinga/content-manager';
import type { PageProps } from '@benzinga/money-utils';

import { getCalendarData, getCalendarBreadcrumbName } from '../calendarMeta';
import { CalendarNewLayoutHeader } from './CalendarNewLayoutHeader';
import DefaultSidebar from '../../../../src/components/Sidebars/DefaultSidebar';
import { ToolsFooter } from '../../tools/ToolsFooter';

const HARD_PAYWALLED_CALENDARS = [
  'unusual-options-activity',
  'earnings',
  'dividends',
  'analyst-ratings',
  'analyst-predictions',
];

export type TradingIdeasCalendarSlug = 'earnings' | 'dividends';

export interface TradingIdeasPageContentProps extends PageProps {
  calendarSlug: TradingIdeasCalendarSlug;
  featuredNews?: any[];
  news?: any[];
  layout?: any;
}

export function TradingIdeasPageContent({ calendarSlug, ...rest }: TradingIdeasPageContentProps) {
  const calendarData = getCalendarData(calendarSlug);
  const basePath = `/${calendarSlug}`;
  const titleFallback = calendarSlug === 'earnings' ? 'Earnings Calendar' : 'Dividends Calendar';
  const breadcrumbs: Breadcrumb[] = [
    { href: '/calendars', id: 'calendars', name: 'Calendars' },
    {
      href: basePath,
      id: calendarSlug,
      name: getCalendarBreadcrumbName(calendarData?.title, titleFallback),
    },
  ];

  return (
    <div
      className={
        calendarSlug === 'dividends'
          ? 'dividends-trading-ideas-page calendar-page-layout-wrapper'
          : 'calendar-page-layout-wrapper'
      }
    >
      <div className={`calendar-page-layout calendar-page-layout--${calendarSlug} new-design`}>
        <MoneyPageTemplate
          layoutHeader={
            <CalendarNewLayoutHeader
              breadcrumbs={breadcrumbs}
              title={calendarData?.name ?? titleFallback}
              description={calendarData?.description}
              dateTimestamp={calendarData?.calendarDate?.getTime() ?? null}
              canonical={`https://www.benzinga.com${basePath}/trading-ideas`}
              showEdgeBadge={HARD_PAYWALLED_CALENDARS.includes(calendarSlug)}
              basePathOverride={basePath}
            />
          }
          layoutAboveArticle={
            <NewsTemplate
              {...rest}
              layoutSidebar={
                <div>
                  <React.Suspense>
                    <DefaultSidebar />
                  </React.Suspense>
                </div>
              }
            />
          }
          post={null}
          width="wide"
        />
        <ToolsFooter currentCalendar={calendarSlug} />
      </div>
    </div>
  );
}
